import React from 'react'
import { Callout, H5, Intent } from '@blueprintjs/core'
import { sanitizedApiField, toTitleCase } from '../utils'

function renderErrs(e) {
  if (!e.errors) return null
  const { errors } = e

  if (typeof errors === 'string') {
    return errors
  }

  return (
    <ul>
      {Object.keys(errors || {}).map(k => {
        return (
          <li key={k}>
            <strong>
              {sanitizedApiField(k)
                .replace('Shopgoodwill Listing ', '')
                .replace('Shopgoodwill ', '')
                .replace('Seller Private Description', 'Barcode')
                .replace(/_[0-9]+/, '') // variants_0InventoryLocationId -> variantsInventoryLocationId
                .replace('Category Market Category', 'Category')}{' '}
            </strong>
            {Array.isArray(errors[k]) ? errors[k].join(', ') : JSON.stringify(errors[k])}
          </li>
        )
      })}
    </ul>
  )
}

function renderErrMessage(message, messageHeader) {
  if (!message) return null
  return (
    <div>
      {messageHeader && <h5 className="bp3-callout-title bp3-heading">{messageHeader}</h5>}

      {/* Think this is a valid reason of dangerous */}
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  )
}

export default class Errors extends React.PureComponent<any> {
  render() {
    const err = this.props.error
    const { marketErrors } = this.props
    if (!err) return null
    return (
      <Callout
        intent={Intent.DANGER}
        style={{ marginBottom: '20px' }}
        title={toTitleCase(err.message) || `Please correct the following`}
      >
        {renderErrs(err)}
        {renderErrMessage(this.props.message, this.props.messageHeader)}
        <br />
        {marketErrors && (
          <>
            <H5>The following errors require a List or Relist action, before they can be corrected</H5>
            <span style={{ fontStyle: 'italic' }}>
              Please go the Listing drawer and try to relist this item if you have corrected the problem.
            </span>
            {renderErrs(marketErrors)}
          </>
        )}
      </Callout>
    )
  }
}
